import { axiosInstance } from '../../App';

import { ManagerGeneralDataDTO, ManagerFiscalDataDTO, SaveManagerDTOBackend } from "../../interface/ManagerType";
import { Address, mobilePhoneToString, toISOString, validMobileForInputPhone } from "medere-ui-framework";
import { GetItemsProps } from "medere-ui-framework";
import { ComboDataDTO } from '../../dto/ComboDataDTO';

export function useManagerService() {
function loadManagers(offSet: number, pageSize: number, params: any){
    return axiosInstance.post("/api/secured/managers/managerForGrid",{
        offSet,
        pageSize,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
    },{
     params:{
          active: params.active,
    }
    }).then((response) => response.data);
}
function getManagerStates({offSet, pageSize, filterValue}:GetItemsProps ){
  
    return axiosInstance.get('/api/secured/managers/getStates',{
        params: {
            offSet,
            pageSize,
            inputtext:filterValue
        }
    }).then(res=>res.data)
}

function convertToBackendDTO(dto: ManagerGeneralDataDTO): SaveManagerDTOBackend {
    return {
      ...dto,
      addresses: dto.addresses.map(convertAddress)
    };
}

function getComboName(type: any): string {
    if (!type) return "";
    return String(type.description ?? type.name ?? "").trim();
}

function convertAddress(address: Address): any {
    const firstPhone = address.phones?.find((phone: any) => (phone?.phonenumber?.number ?? "").trim() !== "");
    return {
        address: address.address > 0 ? address.address : -1,
        addressdesc: address.addressdesc ?? "",
        telephone: firstPhone ? mobilePhoneToString(firstPhone.phonenumber) : "",
        postalcode: address.postalcode ?? "",
        medereentity: address.medereentity && address.medereentity > 0 ? address.medereentity : null,
        city: address.city > 0 ? address.city : null,
        cityExternalId: (address as any).cityExternalId ?? false,
        citydesc: address.citydesc ?? "",
        email: address.email ?? "",
        types: (address.types ?? []).map((type: any): ComboDataDTO => ({
            id: type?.id ?? -1,
            name: getComboName(type),
        })),
        hasChanges: address.hasChanges ?? true,
    };
}
function createManager(manager: ManagerGeneralDataDTO) {
    return axiosInstance.post(`/api/secured/managers/createManager`, convertToBackendDTO(manager), {
    }).then(res => res);
  }

function toReactEntity(entity: ManagerGeneralDataDTO) {
    if (entity) {
      entity.addresses?.forEach((address: any) => {
        address.telephone = validMobileForInputPhone(address.telephone);
      });
      return entity;
    } else return null
  
  }
function getManagerGeneralData(managerId: number) {
    return axiosInstance.get("/api/secured/managers/getManagerGeneralData", {
      params: {
        managerId
      }
    }).then((response) => {
      if (response.data.user)
        response.data.user.password = "";
      return toReactEntity(response.data);
    });
  }
function updateManager(manager: ManagerGeneralDataDTO) {
    return axiosInstance.post(`/api/secured/managers/updateManager`, convertToBackendDTO(manager), {
    }).then(res => res);
  }
function deleteManager(managerId: number) {
    return axiosInstance.post(`/api/secured/managers/deleteManager`, null, {
      params: {
        managerId
      }
    })
  }
function getManagerFiscalData(managerId: number) {
    return axiosInstance.get(`/api/secured/managers/getManagerFiscalData`, {
      params: {
        managerId
      }
    }).then(res => res.data);
  }
function saveManagerFiscalData(manager: ManagerFiscalDataDTO) {
    return axiosInstance.post(`/api/secured/managers/saveManagerFiscalData`, 
    {
      ...manager, 
      iibbFromDate: toISOString(manager.iibbFromDate ? new Date(manager.iibbFromDate) : undefined),
      iibbToDate: toISOString(manager.iibbToDate ? new Date(manager.iibbToDate) : undefined),
    }).then(res => res);
  }
function updateManagerFiscalData(manager: ManagerFiscalDataDTO) {
    return axiosInstance.post(`/api/secured/managers/updateManagerFiscalData`, 
    {
      ...manager, 
      iibbFromDate: toISOString(manager.iibbFromDate ? new Date(manager.iibbFromDate) : undefined),
      iibbToDate: toISOString(manager.iibbToDate ? new Date(manager.iibbToDate) : undefined),
    }
    ).then(res => res);
  }
function addHealthEntityToManager(healthEntityId: number, managerId: number) {
    return axiosInstance.post(`/api/secured/managers/addHealthEntityToManager`, null, {
      params: {
        healthEntityId,
        managerId
      }
    });
  }
function removeHealthEntityFromManager(healthEntityId: number, managerId: number) {
    return axiosInstance.post(`/api/secured/managers/removeHealthEntityFromManager`, null, {
      params: {
        healthEntityId,
        managerId
      }
    });
  }
function getHealthEntitiesByManager(offSet: number, pageSize: number, params: any) {
    return axiosInstance.get(`/api/secured/managers/getHealthEntitiesByManager`, {
      params: {
        offSet,
        pageSize,
        managerId: params.managerId,
      }
    }).then(res => res.data);
  }
function getAllHealthEntitiesToAddToManager({offSet, pageSize, filterValue, params}:GetItemsProps<{
    managerId: number
  }>) {
    return axiosInstance.get(`/api/secured/managers/getAllHealthEntitiesToAddToManager`, {
      params: {
        inputtext:filterValue,
        offSet,
        pageSize,
        managerId: params?.managerId,
      }
    }).then(res => res.data);
  }
function getManagerContactTypes(inputText: any, offSet: any, pageSize: any,){
    return axiosInstance.get(`/api/secured/managers/getManagerContactTypes`,{
      params:{
        inputText,
        offSet,
        pageSize
      }
    }).then(res=>res.data);
  }
function getcompmedicalservicestaxtype({filterValue, offSet, pageSize}:GetItemsProps) {
    return axiosInstance.get('/api/secured/managers/getcompmedicalservicestaxtype', {
      params: {
        inputText: filterValue,
        offSet: offSet,
        pageSize: pageSize
      }
    }).then(res => res.data)
  }
function getAllAddressTypesForPatientEntity(){
    return axiosInstance.get(
        '/api/secured/managers/getAllAddressTypesForPatientEntity',
        )
        .then(res => {
            return res.data;
        });
  }
function getVatCustomerCategories({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get(`/api/secured/managers/getVatCustomerCategories`, {
      params: {
        inputText: filterValue ?? '',
        offSet,
        pageSize
      }
    }).then((response) => response.data)
  }

  return {
    loadManagers,
    getManagerStates,
    createManager,
    getManagerGeneralData,
    updateManager,
    deleteManager,
    getManagerFiscalData,
    saveManagerFiscalData,
    updateManagerFiscalData,
    addHealthEntityToManager,
    removeHealthEntityFromManager,
    getHealthEntitiesByManager,
    getAllHealthEntitiesToAddToManager,
    getManagerContactTypes,
    getcompmedicalservicestaxtype,
    getAllAddressTypesForPatientEntity,
    getVatCustomerCategories,
  }
}
